<template>
  <div class="d-flex flex-column align-items-center justify-content-center  w-100">
    <transition-group name="list-a" tag="el-row" class="main-card-container" :gutter="20" :css="animated">
      <el-col v-bind="responsiveCol" v-for="member in mainMembers" :key="member._id">
        <div v-if="!isRegister" class="mb-05 ml-10">
        Primary Profile
        <el-tooltip class="item" effect="dark" placement="top-start">
          <div slot="content" class="tooltip-mobile">The Primary profile is the holder of this account, other members are managed by the primary account holder</div>
          <i class="el-icon-info"></i>
        </el-tooltip>
        </div>
        <el-card v-if="!isFormSubmit" shadow="never" :class="{ 'box-card': true, 'member-card': true, 'd-flex': true, 'flex-column': true, 'form-submit': isFormSubmit }">
          <div class="d-flex flex-column">
            <div class="flex-1 d-flex">
              <div class="member-avatar flex-0 d-flex align-items-center">
                <el-avatar class="d-flex flex-center fs-25" icon="el-icon-user-solid" :size="65" :src="getMemberAvatar(member)"></el-avatar>
              </div>
              <div class="member-info flex-1 d-flex flex-column">
                <div class="name">{{ member.profile.firstName }} {{ member.profile.lastName }}</div>
                <div class="description">
                  <!-- <vue-clamp autoresize :max-lines="5">{{ member.profile.bio }}</vue-clamp> -->
                  <!-- <vue-clamp autoresize :max-lines="5">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</vue-clamp> -->
                  <div><span class="fw-bold">Date of Birth:</span> {{ formatBirthdate(member.profile.dob, true) }}</div>
                  <div><span class="fw-bold">Gender:</span> {{ member.profile.gender }}</div>
                  <div><span class="fw-bold">Mobile:</span> {{ member.profile.mobile || '-' }}</div>
                  <div><span class="fw-bold">Email:</span> {{ member.profile.email || '-' }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="member-btn d-flex justify-content-center flex-0" v-if="!isFormSubmit">
            <el-button v-if="member.isLocked" type="info" class="disabled color-highlight bd-0 w-100" :disabled="isRegister" @click="editDetail(member._id)">Locked</el-button>
            <el-button v-if="!member.isLocked && !isRegister" type="primary" class="color-highlight bd-0 w-100" @click="editDetail(member._id)">View</el-button>
            <el-button v-if="!member.isLocked && !isRegister" type="primary" class="color-highlight bd-0 w-100" @click="register(member._id)">Register</el-button>
            <el-button v-if="!member.isLocked && isRegister && !member.isUpgradeEligible && !hasPayAfter(member)" type="primary" class="bd-0 w-100" :class="!checkAgeInRange(member._id) ? '' : 'color-highlight'" @click.stop="selectMember(member._id)" :disabled="!checkAgeInRange(member._id)">{{!checkAgeInRange(member._id) ? 'Age is Not in Range' : 'Select'}}</el-button>
            <el-button v-if="!member.isLocked && isRegister && member.isUpgradeEligible" type="primary" class="color-highlight bd-0 w-100" @click="upgradeMember(member._id)">Upgrade</el-button>
            <el-button v-if="!member.isLocked && isRegister&& hasPayAfter(member)" type="primary" class="color-highlight bd-0 w-100"  @click="deRoutePartialPayment(member)">Pay Now</el-button>
            <el-button v-if="!member.isLocked && !isRegister" type="secondary" icon="el-icon-delete" @click="remove(member._id)" disabled></el-button>
          </div>
        </el-card>
        <!--- This card below is for form only, -> JD --->
        <el-card v-else shadow="never" :class="{ 'box-card': true, 'member-card': true, 'd-flex': true, 'flex-column': true, 'form-submit': isFormSubmit }" @click.native="selectMember(member._id)">
          <div class="d-flex flex-column">
            <div class="flex-1 d-flex">
              <div class="member-avatar flex-0 d-flex align-items-center">
                <el-avatar class="d-flex flex-center fs-25" icon="el-icon-user-solid" :size="65" :src="getMemberAvatar(member)"></el-avatar>
              </div>
              <div class="member-info flex-1 d-flex flex-column">
                <div class="name">{{ member.profile.firstName }} {{ member.profile.lastName }}</div>
                <div class="description">
                  <!-- <vue-clamp autoresize :max-lines="5">{{ member.profile.bio }}</vue-clamp> -->
                  <!-- <vue-clamp autoresize :max-lines="5">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</vue-clamp> -->
                  <div><span class="fw-bold">Date of Birth:</span> {{ formatBirthdate(member.profile.dob, true) }}</div>
                  <div><span class="fw-bold">Gender:</span> {{ member.profile.gender }}</div>
                  <div><span class="fw-bold">Mobile:</span> {{ member.profile.mobile || '-' }}</div>
                  <div><span class="fw-bold">Email:</span> {{ member.profile.email || '-' }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="member-btn d-flex justify-content-center flex-0" v-if="!isFormSubmit">
            <el-button v-if="member.isLocked" type="info" class="disabled color-highlight bd-0 w-100" :disabled="isRegister" @click="editDetail(member._id)">Locked</el-button>
            <el-button v-if="!member.isLocked && !isRegister" type="primary" class="color-highlight bd-0 w-100" @click="editDetail(member._id)">View</el-button>
            <el-button v-if="!member.isLocked && !isRegister" type="primary" class="color-highlight bd-0 w-100" @click="register(member._id)">Register</el-button>
            <el-button v-if="!member.isLocked && isRegister && !member.isUpgradeEligible && !hasPayAfter(member)" type="primary" class=" color-highlight bd-0 w-100" :class="!checkAgeInRange(member._id) ? '' : 'color-highlight'" @click.stop="selectMember(member._id)" :disabled="!checkAgeInRange(member._id)">{{!checkAgeInRange(member._id) ? 'Age is Not in Range' : 'Select'}}</el-button>
            <el-button v-if="!member.isLocked && isRegister&& hasPayAfter(member)" type="primary" class="color-highlight bd-0 w-100" @click="deRoutePartialPayment(member)" >Pay Now</el-button>
            <el-button v-if="!member.isLocked && isRegister && member.isUpgradeEligible" type="primary" class="color-highlight bd-0 w-100" @click="upgradeMember(member._id)">Upgrade</el-button>
            <el-button v-if="!member.isLocked && !isRegister" type="secondary" icon="el-icon-delete" @click="remove(member._id)" disabled></el-button>
          </div>
        </el-card>
      </el-col>
    </transition-group>
    <el-row class="main-card-container" :gutter="20">
      <el-col :span="24">
      <el-divider v-if="mainMembers.length" />
      </el-col>
      <transition-group tag="div" name="list" :css="animated">
        <el-col v-bind="responsiveCol" v-for="member in sideMembers" :key="member._id">
          <el-card v-if="!member.mainProfile" shadow="never" :class="{ 'box-card': true, 'member-card': true, 'd-flex': true, 'flex-column': true, 'form-submit': isFormSubmit }" @click.native="selectMember(member._id)">
            <div class="d-flex flex-column">
              <div class="flex-1 d-flex">
                <div class="member-avatar flex-0 d-flex align-items-center">
                  <el-avatar class="d-flex flex-center fs-25" icon="el-icon-user-solid" :size="65" :src="getMemberAvatar(member)"></el-avatar>
                </div>
                <div class="member-info flex-1 d-flex flex-column">
                  <div class="name">{{ member.profile.firstName }} {{ member.profile.lastName }}</div>
                  <div class="description ">
                    <!-- <vue-clamp autoresize :max-lines="5">{{ member.profile.bio }}</vue-clamp> -->
                    <!-- <vue-clamp autoresize :max-lines="5">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</vue-clamp> -->
                    <div><span class="fw-bold">Date of Birth:</span> {{ formatBirthdate(member.profile.dob, true) }}</div>
                    <div><span class="fw-bold">Gender:</span> {{ member.profile.gender }}</div>
                    <div><span class="fw-bold">Mobile:</span> {{ member.profile.mobile || '-' }}</div>
                    <div class="email" ><span class="fw-bold">Email:</span>{{ member.profile.email || '-' }}</div>
                  </div>
                </div>
              </div>
              <div class="mt-10">
                <el-checkbox v-if="!member.isLocked && !isRegister" v-model="member.mainProfile" :disabled="member.mainProfile || disablePrimaryCheckbox" @change="checkMember(member)" :key="key">Make this my primary profile</el-checkbox>
                <small v-if="member.isLocked">Please contact your administrator to resolve</small>
              </div>
            </div>
            <div class="member-btn d-flex justify-content-center flex-0" v-if="!isFormSubmit">
              <el-button v-if="member.isLocked" type="info" class="disabled color-highlight bd-0 w-100" :disabled="isRegister" @click="editDetail(member._id)">Locked</el-button>
              <el-button v-if="!member.isLocked && !isRegister" type="primary" class="color-highlight bd-0 w-100" @click="editDetail(member._id)">View</el-button>
              <el-button v-if="!member.isLocked && !isRegister" type="primary" class="color-highlight bd-0 w-100" @click="register(member._id)">Register</el-button>
              <el-button v-if="!member.isLocked && isRegister && !member.isUpgradeEligible && !hasPayAfter(member)" type="primary" class="bd-0 w-100" :class="!checkAgeInRange(member._id) ? '' : 'color-highlight'" @click.stop="selectMember(member._id)" :disabled="!checkAgeInRange(member._id)">{{!checkAgeInRange(member._id) ? 'Age is Not in Range' : 'Select'}}</el-button>
              <el-button v-if="!member.isLocked && isRegister&& hasPayAfter(member)" type="primary" class="color-highlight bd-0 w-100" @click="deRoutePartialPayment(member)"  >Pay Now</el-button>
              <el-button v-if="!member.isLocked && isRegister && member.isUpgradeEligible" type="primary" class="color-highlight bd-0 w-100" @click="upgradeMember(member._id)">Upgrade</el-button>
              <el-button v-if="!member.isLocked && !isRegister" type="secondary" icon="el-icon-delete" @click="remove(member._id)" ></el-button>
            </div>
          </el-card>
        </el-col>
      </transition-group>
      <el-col v-bind="responsiveCol">
        <el-card class="box-card member-add pointer bds-dash" shadow="never" @click.native="addMemberModal.visible = true">
          <div class="op-5"><img src="~@/assets/icons/add-member.svg"></div>
          <div class="mt-10 c-lightblack op-5">Add Member</div>
        </el-card>
      </el-col>
    </el-row>
    <el-dialog
      :title="addMemberModal.page.title"
      :visible.sync="addMemberModal.visible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :before-close="beforeAddMemberModalClose"
      :append-to-body="!!isRegister">
      <new-member v-if="addMemberModal.page.name === 'new-member'" @updatePage="updatePage" @updateVisible="updateVisible" @refreshMembers="refreshMembers" />
      <link-member v-if="addMemberModal.page.name === 'link-member'" @updatePage="updatePage" @updateVisible="updateVisible" @refreshMembers="refreshMembers" :data="addMemberModal.data" />
      <verify-member v-if="addMemberModal.page.name === 'verify-member'" @updatePage="updatePage" @updateVisible="updateVisible" @refreshMembers="refreshMembers" :data="addMemberModal.data" />
    </el-dialog>
  </div>
</template>

<script>
// import VueClamp from 'vue-clamp';
import _ from 'lodash';
import moment from 'moment';
import { parseBirthdate } from '@/utils/form-helpers';
import { calculateMemberAge } from '@/utils/helpers';
import NewMember from './NewMember.vue';
import LinkMember from './LinkMember.vue';
import VerifyMember from './VerifyMember.vue';

const findMatchingMemberships = (membership, productRequirement) => {
  console.log('FINDING MATCHING MEMBERSHIP');
  console.log({ membership, productRequirement });

  if (_.get(productRequirement, 'products.type') === 'family') {
    const familyMembership = _.filter((membership), (m) => m.productType === 'family' && m.productId === _.get(productRequirement, 'products._id'));
    return familyMembership;
  }

  const tagArray = _.get(productRequirement, 'products.tags', []);
  if (tagArray && tagArray.length) {
    return membership.filter((m) => _.get(m, 'products.tags', [])
    && _.get(productRequirement, 'products.tags', []).length === tagArray.length
    && _.get(productRequirement, 'products.tags', []).every((tag, index) => tag._id === tagArray[index]._id)
    && productRequirement._id === m.entityId
    && _.get(productRequirement, 'products.type') === m.productType
    && _.get(productRequirement, 'products.memberType') === m.memberType);
  }

  console.log({
    filter: membership.filter((m) => (productRequirement._id === m.entityId
    && _.get(m, 'regoEntity.products.type') === m.productType
    && _.get(m, 'regoEntity.products.memberType') === m.memberType))
  });

  console.log({
    filter: membership.filter((m) => (productRequirement._id === m.entityId
    && _.get(m, 'regoEntity.products.type') === m.productType))
  }, 'family');

  return membership.filter((m) => (productRequirement._id === m.entityId
    && _.get(productRequirement, 'products.type') === m.productType
    && _.get(productRequirement, 'products.memberType') === m.memberType));
};

const filterMembersWithRequiredMembership = (members, products, membership) => {
  console.log('members', members);
  console.log('products', products);
  console.log('membership', membership);
  const foundMemberships = products[0].membershipProductsRequired.reduce((updatedMembership, productRequirement) => {
    const found = findMatchingMemberships(membership, productRequirement);
    if (found.length) updatedMembership.push(found);
    return updatedMembership;
  }, []);
  const flattenedMemberships = _.flatten(foundMemberships);
  return flattenedMemberships.length
    ? members.filter((m) => flattenedMemberships.map((fm) => fm.memberId).includes(m._id))
    : [];
};

const requiredMembershipInStore = (self, members, products) => {
  const cartRegistrations = self.$store.state.cart.registrations;
  const foundMemberships = products[0].membershipProductsRequired.reduce((updatedMembership, productRequirement) => {
    // console.log('productRequirement', productRequirement);
    // console.log(cartRegistrations[0]);
    const found = findMatchingMemberships(cartRegistrations, productRequirement);
    if (found.length) updatedMembership.push(found);
    return updatedMembership;
  }, []);
  console.log({ foundMemberships });
  const flattenedMemberships = _.flatten(foundMemberships);
  console.log({ members, flattenedMemberships });
  return flattenedMemberships.length
    ? members.filter((m) => flattenedMemberships.map((fm) => fm.memberId).includes(m._id))
    : [];
};

const filterMembersEligibleForUpgrade = (self, members, membership) => {
  const foundMembershipIds = membership ? membership
    .filter((m) => m.entityType === 'membership' && _.get(m, 'regoEntity.products.isUpgradeable'))
    .reduce((ids, foundMembership) => {
      const upgradeableList = foundMembership.regoEntity.products.upgradeableMembershipList || [];
      // eslint-disable-next-line no-restricted-syntax
      for (const upgradeable of upgradeableList) {
        if (upgradeable._id === self.rego._id && upgradeable.products.some((p) => p._id === self.rego.products[0]._id)) {
          ids.push(foundMembership.memberId);
          break;
        }
      }
      return ids;
    }, []) : [];
  // eslint-disable-next-line no-confusing-arrow
  return members.map((member) => foundMembershipIds.includes(member._id) ? _.assign(member, { isUpgradeEligible: true }) : member);
};

const filterByProducts = (self, members, membership) => {
  let filtered = [];
  if (!self.isRegister || !_.includes(['indv', 'indv-to-team', 'family'], self.productType) || !self.products || self.products.length === 0) {
    console.log('members', members);
    return members;
  }
  filtered = members.filter((member) => self.products.some((p) => p.gender === member.profile.gender || p.gender === 'All' || (p.gender === 'Other' && (member.profile.gender === 'Male' || member.profile.gender === 'Female'))));
  console.log('filtered', filtered);
  if (self.rego.registrationType === 'membership') {
    const membersEligibleForUpgrade = filterMembersEligibleForUpgrade(self, members, membership);
    // Place each of the members that are eligible for upgrade into the filtered array
    filtered = filtered.map((member) => membersEligibleForUpgrade.find((m) => m._id === member._id) || member);
    console.log('filtered 2', filtered);
  }

  if (self.products.some((p) => p.isMembershipRequired)) {
    const hasRegistration = filterMembersWithRequiredMembership(members, self.products, membership);
    console.log('hasRegistration', hasRegistration);
    const intendToRegister = requiredMembershipInStore(self, members, self.products);
    console.log('intendToRegister', intendToRegister);
    filtered = hasRegistration.concat(intendToRegister);
  }
  console.log('filtered 3', filtered);
  return filtered;
};

const loadMembers = (self) => {
  self.$store.commit('loading', { loading: true, text: 'Loading...' });

  let accreditationIds = [];
  if (_.get(self, 'products[0].isAccreditationRequired', false)) {
    accreditationIds = _.map(_.get(self, 'products[0].accreditationProductsRequired', []), (a) => a._id);
  }

  Promise.all([
    self.$http.get('/assemble/api/v1/account/portal/members'),
    self.$http.get('/assemble/api/v1/portal/registrations/members'),
    self.$http.post('/assemble/api/v1/portal/registrations/member-accreditations', { accreditationIds }),
  ]).then(([resMember, membershipResponse, resAccredMember]) => {
    const memberRegistrations = membershipResponse.data.data;
    // eslint-disable-next-line no-param-reassign
    self.memberMemberships = memberRegistrations;
    let members = resMember.data.data;
    const resAccredMemberIds = resAccredMember.data.data;

    // Filter members with accreditation
    if (accreditationIds.length > 0) {
      members = members.filter((m) => _.includes(resAccredMemberIds, m._id));
    }

    // Further filter members by products, membership requirements, etc.
    members = filterByProducts(self, members, memberRegistrations);
    console.log('filtered members', members);

    // eslint-disable-next-line no-param-reassign
    self.members = members;
    // eslint-disable-next-line no-param-reassign
    self.sideMembers = members.filter((m) => m.mainProfile !== true);
    // eslint-disable-next-line no-param-reassign
    self.mainMembers = members.filter((m) => m.mainProfile === true);
    self.$store.commit('loading', false);
  }).catch((e) => {
    console.log({ e });
    self.$message.error(e.response.data.message);
    self.$store.commit('loading', false);
  });
};

export default {
  name: 'MemberBoard',
  props: {
    productType: String,
    products: Array,
    isRegister: Boolean,
    isFormSubmit: Boolean,
    animated: Boolean,
    isMembershipRequired: Boolean,
    disablePrimaryCheckbox: Boolean,
    accreditationRequired: Array,
    rego: Object
  },
  components: {
    NewMember,
    LinkMember,
    VerifyMember
  },
  data() {
    return {
      key: 0,
      addMemberModal: {
        visible: false,
        page: {
          name: 'new-member',
          title: 'Add Member'
        },
        data: undefined
      },
      members: [],
      memberMemberships: [],
      sideMembers: [],
      mainMembers: [],
      // responsiveCol: {
      //   xs: 24, sm: 12, md: 12, lg: 12
      // }
    };
  },
  computed: {
    hasCustomEntity() {
      const customEntity = this.$store.getters['national/getEntity'];
      if (customEntity && customEntity.level && customEntity.name) {
        return true;
      }
      return false;
    },
    responsiveCol() {
      const mediumToLarge = this.isFormSubmit || this.isRegister ? 12 : 8;
      return {
        xs: 24, sm: 12, md: mediumToLarge, lg: mediumToLarge
      };
    },

  },
  async mounted() {
    // if (this.isRegister) {
    //   this.responsiveCol = {
    //     xs: 24, sm: 12, md: 12, lg: 12
    //   };
    // }
    loadMembers(this);
  },
  methods: {
    hasPayAfter(member) {
      if (this.rego && this.memberMemberships && this.memberMemberships.length > 0) {
        const foundProduct = this.memberMemberships.find((m) => m.entityId === this.rego._id && m.memberId === member._id && m.productId === this.rego.products[0]._id);
        if (foundProduct && foundProduct.payAfter && !foundProduct.payAfterMeta.fullyPaid) {
          // return foundProduct.payAfter;
          return true;
        }
      }
      return false;
    },
    deRoutePartialPayment(member) {
      const foundProduct = this.memberMemberships && this.memberMemberships.length && this.memberMemberships.find((m) => m.entityId === this.rego._id && m.memberId === member._id && m.productId === this.rego.products[0]._id);
      const pathName = this.hasCustomEntity ? 'custom-partial-payment' : 'partial-payment';
      this.$router.push({ name: pathName, params: { id: foundProduct._id } });
    },
    checkAgeInRange(memberId) {
      const { entityType, entityCustomDateCutoff } = this.rego;
      let endOfYear = this.$store.getters['national/endOfYear'];
      if (entityType !== 'national' && entityCustomDateCutoff && entityCustomDateCutoff.useCustomDateCutoff) {
        const { customDateCutoffMonth, customDateCutoffDay } = entityCustomDateCutoff;
        // endOfYear is ${currentYear}-${customDateCutoffMonth}-${customDateCutoffDay} in string format
        endOfYear = `${moment().year()}-${customDateCutoffMonth}-${customDateCutoffDay}`;
        console.log({ customDateCutoffMonth, customDateCutoffDay, endOfYear });
      }
      const member = _.find(this.members, { _id: memberId });
      const age = calculateMemberAge(member.profile.dob, endOfYear);
      return _.find(this.products, (p) => age >= p.ageFrom && age <= p.ageTo) !== undefined;
    },
    async checkAndInformBeforeProceed(memberId) {
      let result = true;
      try {
        if (this.isRegister && _.includes(['indv', 'indv-to-team'], this.productType) && this.products && this.products.length > 0) {
          if (!this.checkAgeInRange(memberId)) {
            result = false;
            this.$confirm("The member you have selected does not meet the ‘Age' requirements for this event / membership.", 'Member Age Not In Range', {
              confirmButtonText: 'Ok',
              showCancelButton: false,
            });
          }
        }
      } catch (e) {
        console.log(e);
      }
      return result;
    },
    getMemberAvatar(member) {
      return _.get(member, 'meta.imgUrl', '') ? `${member.meta.imgUrl}?v=${moment().valueOf()}` : '';
    },
    checkMember(member) {
      if (member._id) {
        this.animated = true;
        const currentMain = this.mainMembers.find((m) => m.mainProfile === true);
        _.assign(currentMain, { mainProfile: false });
        this.members.map((m) => _.assign(m, { mainProfile: false }));
        _.assign(member, { mainProfile: true });
        this.mainMembers[0] = member;
        const indexToReplace = this.sideMembers.indexOf(member);
        this.sideMembers.splice(indexToReplace, 1);
        this.sideMembers.splice(indexToReplace, 0, { ...currentMain });
        this.$store.commit('loading', { loading: true, text: 'Loading...' });
        this.$http.put(`/assemble/api/v1/account/portal/members/${member._id}/primary`)
          .then(() => {
            this.$store.commit('loading', false);
            this.$message.success(`${member.profile.firstName} ${member.profile.lastName} has been set as primary profile`);
          }).catch((e) => {
            this.$message.error(e.response.data.message);
            this.$store.commit('loading', false);
          });
      }
    },
    updatePage(page, data) {
      this.addMemberModal.page = page;
      this.addMemberModal.data = data;
    },
    updateVisible(val) {
      this.addMemberModal.visible = val;
    },
    refreshMembers() {
      loadMembers(this);
    },
    beforeAddMemberModalClose() {
      this.addMemberModal = {
        visible: false,
        page: {
          name: 'new-member',
          title: 'Add Member'
        },
        data: undefined
      };
    },
    editDetail(id) {
      const pathName = this.hasCustomEntity ? 'custom-profile' : 'profile';
      this.$router.push({ name: pathName, params: { id } });
    },
    register(id) {
      const member = _.find(this.members, { _id: id });
      // commit to store
      if (member) {
        this.$store.commit('user/updateSelectMember', member);
      }
      const pathName = this.hasCustomEntity ? 'custom-finder' : 'finder';
      this.$router.push({ name: pathName, params: { memberId: id } });
      // this.$router.push('register');
    },
    formatBirthdate(val) {
      return parseBirthdate(val, true);
    },
    upgradeMember(memberId) {
      this.$confirm('Do you want to register new membership or upgrade your existing one from the registration history?', 'Confirm', {
        distinguishCancelAndClose: true,
        confirmButtonText: 'Upgrade',
        cancelButtonText: 'Register',
      }).then(() => {
        const pathName = this.hasCustomEntity ? 'custom-profile' : 'profile';
        this.$router.push({
          name: pathName,
          params: {
            id: memberId, upgradingMembership: true, tabName: 'rego-history', regoId: this.rego._id, regoProductId: this.rego.products[0]._id
          }
        });
      }).catch((action) => {
        if (action === 'cancel') {
          this.selectMember(memberId);
        }
      });
    },
    async selectMember(memberId) {
      const checkResult = await this.checkAndInformBeforeProceed(memberId);
      const member = _.find(this.members, { _id: memberId });
      // commit to store
      if (member) {
        this.$store.commit('user/updateSelectMember', member);
      }
      if (checkResult) {
        this.$emit('select-member', memberId);
      }
    },
    remove(memberId) {
      this.$confirm('Are you sure you want to unlink this member?', 'Confirm', {
        distinguishCancelAndClose: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      })
        .then(() => {
          this.$store.commit('loading', { loading: true, text: 'Loading...' });
          this.$http.put(`/assemble/api/v1/account/portal/members/${memberId}/unlink`)
            .then(() => {
              this.$store.commit('loading', false);
              this.animated = false;
              this.sideMembers = _.filter(this.sideMembers, (m) => m._id !== memberId);
              this.$message.success('Member has been unlinked successfully');
            }).catch((e) => {
              this.$message.error(e.response.data.message);
              this.$store.commit('loading', false);
            });
        })
        .catch(() => {});
    }
  },
};
</script>

<style lang="scss" scoped>
.list-enter-active,
.list-leave-active,
.list-a-enter-active,
.list-a-leave-active,
.list-move,
.list-a-move {
  transition: 1100ms cubic-bezier(.49,.91,.31,.96);
  transition-property: opacity, transform;
}
.list-enter {
  opacity: 0;
  transform:  translateY(300px) scaleY(1);
}
.list-a-enter-to,
.list-a-leave-to,
.list-a-enter{
  opacity: 0;
}
.list-leave-active {
  position: absolute;
  top:-230px
}
.list-a-leave-active{
  position: absolute;
  opacity: 0;
}

.main-card-container {
  width: 100%;
  max-width: $md;

  .el-col {
    margin-bottom: 1.5em;
  }

  .member-card {
    padding: 1em;
    min-height: 15em;

    &.form-submit {
      cursor: pointer;
    }

    &.form-submit:hover {
      border: 1px dashed rgba($highlight, 0.5);
    }

    ::v-deep .el-card__body {
      padding: 0.5em;
      display: flex;
      flex-direction: column;
      flex: 1 1 auto;
    }

    .member-avatar {
      width: 5.5em;
      margin-top: -1em;
    }

    .member-info {
      .name {
        font-size: 1.5em;
        flex: 0 0 auto;
      }

      .description {
        padding-top: 0.5em;
        padding-bottom: 0.5em;
        font-size: 0.8em;
        flex: 1 1 auto;
        .email{
          max-width:85%;
          overflow: hidden;
          text-overflow: ellipsis;
        }

      }
    }

    .member-btn {
      padding-top: 1em;
      border-top: 1px solid rgba(45, 58, 69, 0.1);
    }
  }

  .member-add {
    padding: 1em;
    height: 15em;
    border-color: rgba($highlight, 0.5);

    ::v-deep .el-card__body {
      padding: 0.5em;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100%;
    }
  }
}

@media only screen and (max-width: $sm) {
  .tooltip-mobile {
    width: 300px;
  }
}

</style>
<style scoped>
.color-highlight{
  background: var(--highlight-color);
  color: var(--text-color-primary)
}
</style>
